import { render } from "./ImportResultsModal.vue?vue&type=template&id=720f6bee"
import script from "./ImportResultsModal.vue?vue&type=script&lang=js"
export * from "./ImportResultsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__